import { Button, Header, Modal } from 'semantic-ui-react'
import { useTranslation } from 'react-i18next'
import { IEmailAttachment } from './ListAttachment'

export interface IDeleteAttachmentProps {
  open: boolean
  onCancel: () => void
  onConfirm: (AttachmentUUID: string) => Promise<void>
  deletingAttachment: IEmailAttachment | null
  isLoading: boolean
}

export const DeleteAttachment = (props: IDeleteAttachmentProps) => {
  const { t } = useTranslation()

  return (
    <Modal open={props.open} size='small' data-testid='delete-email-attachment-modal'>
      <Header content={t('email_attachment.delete_attch.title')} />
      <Modal.Content>
        <p>
          {t('email_attachment.delete_attch.description')}
          <b>{` ${props.deletingAttachment?.AttachmentName}`}</b>?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button content={t('global.cancel')} icon='cancel' onClick={props.onCancel} data-testid='btn-cancel' />
        <Button
          content={t('global.confirm')}
          color='blue'
          onClick={() => props.onConfirm(props.deletingAttachment?.AttachmentUUID as string)}
          data-testid='btn-confirm'
          loading={props.isLoading}
        />
      </Modal.Actions>
    </Modal>
  )
}
export default DeleteAttachment
